import classnames from 'classnames'
import { marketoFormIds } from 'marketing-site/lib/marketo'
import { MarketoFormV2 } from 'marketing-site/src/library/components/MarketoFormV2'
import { Text } from 'marketing-site/src/library/elements/Text'
import { NewBrandingHoc } from 'marketing-site/src/library/utils/NewBrandingHoc'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { IWebinar } from '../index'
import { WebinarHeroConfirmation } from './confirmation'
import handleFormSubmit from './handleFormSubmit'
import styles from './hero-legacy.scss'
import { WebinarHeroVideo } from './video'
import { WebinarHero as WebinarHeroDefault } from './hero'
import useTranslate from '../../../../library/hooks/useTranslate'
const HIDDEN_FIELDS_IDS = ['question']

export function WebinarHeroLegacy(props: IWebinar): React.ReactElement {
  const router = useRouter()
  const { translate } = useTranslate()
  const [registered, setRegistered] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [playVideo, setPlayVideo] = useState(false)
  const [joinUrl, setJoinUrl] = useState('')
  const [errors, setErrors] = useState<string[] | null>(null)
  const title = props.isScheduled ? 'Register' : 'Share details to watch'
  const subtitle = props.isRecording
    ? 'Register now to watch the recording'
    : 'Register now for the live event'
  const ctaText = props.isScheduled ? 'Register now' : 'Watch now'

  const heroClassNames = classnames('webinars__hero', {
    'webinars__hero-playing': playVideo,
    [`webinars__hero--${props.heroColor}`]: true,
  })

  return (
    <div className="webinars__hero-wrap">
      <div className={heroClassNames} style={{ backgroundColor: props.heroBackgroundColor }}>
        <div className="webinars__hero-inner">
          <div className="webinars__hero-heading">
            <h1>
              <Text size="heading">{props.title}</Text>
            </h1>
            <h2>
              <Text size="lg">{subtitle}</Text>
            </h2>
          </div>

          <div className="webinars__hero-form-wrap">
            <img src={props.heroImage} className="webinars__hero-texture" alt="" />
            {registered ? (
              <WebinarHeroConfirmation firstName={firstName} webinar={props} joinUrl={joinUrl} />
            ) : (
              <div className="webinars__form">
                {!props.isScheduled && !props.isRecording ? (
                  <Text brand="legacy" size="lg+">
                    {translate('This webinar has concluded')}
                  </Text>
                ) : (
                  <>
                    <MarketoFormV2
                      formId={marketoFormIds.webinar}
                      submitButtonLabel={ctaText}
                      hideLabels={true}
                      headingText={title}
                      forceBusinessEmail={true}
                      hiddenFieldIds={props.isRecording ? HIDDEN_FIELDS_IDS : undefined}
                      onSubmit={async (result, values) => {
                        if (!result.success) return
                        await handleFormSubmit({
                          values: values || {},
                          webinarProps: props,
                          utmSource: router.query.utm_source as string,
                          onSuccessfulRegistration: () => setRegistered(true),
                          onFirstNameChange: (firstName) => setFirstName(firstName),
                          onVideoStart: () => setPlayVideo(true),
                          onJoinUrlChange: (joinUrl) => setJoinUrl(joinUrl),
                          onErrorsRaised: (errors) => setErrors(errors),
                        })
                      }}
                    />
                    {errors &&
                      errors.map((error) => (
                        <div key={`error-${error}`} className="webinars__form-error">
                          {error}
                        </div>
                      ))}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
        {playVideo && props.wistiaId && (
          <WebinarHeroVideo
            wistiaId={props.wistiaId}
            thumbnail={props.wistia?.thumbnail}
            title={props.title}
            slug={props.slug}
          />
        )}
        {/* Preload thumbnail */}
        {props.wistia?.thumbnail && (
          <img src={props.wistia?.thumbnail} style={{ display: 'none' }} alt="Video thumbnail" />
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

export const WebinarHero = NewBrandingHoc(WebinarHeroLegacy, WebinarHeroDefault)
